"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagNZ = function FlagNZ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.31v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.49V5.12a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.49L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122h-21.18v56.5H-193v21.18h91.81v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.24a7,7,0,0,0-3.37,5.87v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M123.38,101.87a1.43,1.43,0,0,1-.82-.26l-8.36-6-8.36,6a1.45,1.45,0,0,1-.82.26,1.42,1.42,0,0,1-1.35-1.84l3.1-9.8-8.26-6.09a1.41,1.41,0,0,1,.83-2.55l10.27-.09,3.25-9.74a1.41,1.41,0,0,1,2.68,0l3.25,9.74,10.28.09a1.41,1.41,0,0,1,.82,2.55l-8.26,6.09,3.1,9.8a1.42,1.42,0,0,1-1.35,1.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.2,72.21l3.57,10.7,11.28.09L120,89.7l3.41,10.75-9.18-6.56L105,100.46l3.41-10.76L99.35,83l11.28-.09,3.57-10.7m0-2.83a2.83,2.83,0,0,0-2.68,1.93l-2.93,8.79-9.26.07a2.83,2.83,0,0,0-1.66,5.1l7.45,5.5-2.79,8.83a2.82,2.82,0,0,0,2.69,3.68,2.74,2.74,0,0,0,1.64-.53l7.54-5.38,7.54,5.38a2.74,2.74,0,0,0,1.64.53,2.82,2.82,0,0,0,2.69-3.68l-2.79-8.83,7.45-5.5a2.83,2.83,0,0,0-1.66-5.1l-9.26-.07-2.93-8.79a2.83,2.83,0,0,0-2.68-1.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M123.38-12a1.36,1.36,0,0,1-.82-.26l-8.36-6-8.36,6A1.38,1.38,0,0,1,105-12a1.41,1.41,0,0,1-.83-.26,1.44,1.44,0,0,1-.52-1.58l3.1-9.79-8.26-6.1A1.44,1.44,0,0,1,98-31.3a1.42,1.42,0,0,1,1.34-1l10.27-.08,3.25-9.74a1.41,1.41,0,0,1,1.34-1,1.41,1.41,0,0,1,1.34,1l3.25,9.74,10.28.08a1.4,1.4,0,0,1,1.33,1,1.42,1.42,0,0,1-.51,1.58l-8.26,6.1,3.1,9.79a1.44,1.44,0,0,1-.52,1.58,1.41,1.41,0,0,1-.83.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.2-41.65l3.57,10.7,11.28.09L120-24.16l3.41,10.76L114.2-20,105-13.4l3.41-10.76-9.08-6.7,11.28-.09,3.57-10.7m0-2.82a2.82,2.82,0,0,0-2.68,1.93l-2.93,8.78-9.26.08a2.81,2.81,0,0,0-2.67,1.95,2.84,2.84,0,0,0,1,3.14l7.45,5.5-2.79,8.84a2.83,2.83,0,0,0,1,3.14,2.91,2.91,0,0,0,1.66.54,2.81,2.81,0,0,0,1.64-.53l7.54-5.39,7.54,5.39a2.81,2.81,0,0,0,1.64.53,2.91,2.91,0,0,0,1.66-.54,2.83,2.83,0,0,0,1-3.14l-2.79-8.84,7.45-5.5a2.82,2.82,0,0,0,1-3.14,2.81,2.81,0,0,0-2.67-1.95l-9.26-.08-2.93-8.78a2.82,2.82,0,0,0-2.68-1.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M172.81,23.32a1.45,1.45,0,0,1-.82-.26l-8.35-6-8.36,6a1.47,1.47,0,0,1-.82.26,1.43,1.43,0,0,1-.84-.27,1.45,1.45,0,0,1-.52-1.57l3.11-9.79L148,5.59A1.42,1.42,0,0,1,148.77,3L159.05,3l3.25-9.75a1.41,1.41,0,0,1,1.34-1,1.43,1.43,0,0,1,1.34,1L168.23,3,178.5,3a1.42,1.42,0,0,1,.83,2.56l-8.26,6.1,3.1,9.79a1.42,1.42,0,0,1-1.36,1.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M163.63-6.34l3.57,10.7,11.28.09-9.07,6.7,3.4,10.76-9.18-6.56-9.17,6.56,3.4-10.76-9.08-6.7,11.28-.09,3.57-10.7m0-2.82A2.83,2.83,0,0,0,161-7.24L158,1.55l-9.26.07a2.83,2.83,0,0,0-1.66,5.1l7.45,5.51-2.79,8.83a2.83,2.83,0,0,0,4.34,3.15l7.53-5.39,7.54,5.39a2.82,2.82,0,0,0,1.64.52,2.87,2.87,0,0,0,1.66-.53,2.82,2.82,0,0,0,1-3.14l-2.8-8.83,7.45-5.51a2.83,2.83,0,0,0-1.65-5.1l-9.26-.07-2.93-8.79a2.83,2.83,0,0,0-2.69-1.92Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M74,37.45a1.48,1.48,0,0,1-.83-.26l-8.35-6-8.36,6a1.47,1.47,0,0,1-.82.26,1.4,1.4,0,0,1-.83-.27,1.42,1.42,0,0,1-.52-1.58l3.1-9.79-8.26-6.1a1.41,1.41,0,0,1,.83-2.55l10.27-.08,3.25-9.74a1.41,1.41,0,0,1,2.68,0l3.25,9.74,10.27.08a1.42,1.42,0,0,1,.83,2.55l-8.26,6.1,3.1,9.79A1.42,1.42,0,0,1,74,37.45Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M64.77,7.79l3.57,10.7,11.28.08-9.08,6.71L73.94,36l-9.17-6.56L55.59,36,59,25.28l-9.08-6.71,11.29-.08,3.57-10.7m0-2.83a2.82,2.82,0,0,0-2.68,1.93l-2.93,8.79-9.27.07a2.83,2.83,0,0,0-1.66,5.1l7.46,5.5-2.8,8.83a2.83,2.83,0,0,0,1,3.14,2.79,2.79,0,0,0,1.66.54,2.84,2.84,0,0,0,1.64-.53l7.54-5.39,7.53,5.39a2.82,2.82,0,0,0,4.34-3.15l-2.8-8.83,7.46-5.5a2.83,2.83,0,0,0-1.66-5.1l-9.27-.07L67.45,6.89A2.84,2.84,0,0,0,64.77,5Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagNZ;
exports["default"] = _default;